import CustomSelect from './CustomSelect';

interface SingleSelectInputProps {
  label: string;
  placeholder: string;
  value: string;
  error?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  isMandatory?: boolean;
  options: string[];
}

function SingleSelectInput({
  label,
  placeholder,
  value,
  error,
  onChange,
  disabled = false,
  isMandatory = false,
  options,
}: SingleSelectInputProps) {
  return (
    <div className="d-block w-100 subscribe__property__content__customfield">
      <div className="subscribe__property__content__label">
        {label}
        {isMandatory && <span className="text-danger"> *</span>}
      </div>
      <CustomSelect
        value={value || ''}
        options={options}
        placeholder={placeholder || 'Select...'}
        disabled={disabled}
        isInvalid={!!error}
        onChange={newValue => onChange(newValue as string)}
        multiSelect={false}
        searchable={false}
      />
      {error && (
        <div className="subscribe__property__content__error">{error}</div>
      )}
    </div>
  );
}

export default SingleSelectInput;
